<template>
  <div id="createDatasetDrawer">
    <!-- Create Dataset -->
    <b-card
      id="createDatasetDrawerCard"
      class="blockDrawer large"
      :class="$store.state.drawer.createDataset.position"
    >
      <template v-slot:header>
        <a
          class="close clickable"
          @click="closeCreateDatasetDrawer()"
        >
          <i class="far fa-times"></i>
        </a>

        <h4 v-if="$store.state.display.editMode == false" id="datasetTitle"><i class="fas fa-file-upload"></i> Upload Dataset</h4>
        <h4 v-if="$store.state.display.editMode" id="datasetTitle">Dataset Settings</h4>
      </template>
      <p v-if="$store.state.dataset.dynamic"><strong>Dynamic Dataset:</strong> These settings will also update your data collector settings!</p>
      <form @submit.prevent class="mb-5 pb-5">
        <!-- NAME -->
        <div class="form-group">
          <label for="datasetName">Name</label>
          <input
            v-model="tempDataset.name"
            id="datasetName"
            class="form-control"
          />
        </div><!-- /.form-group -->

        <!-- DESCRIPTION -->
        <div class="form-group">
          <label for="datasetDescription">Description</label>
          <textarea
            v-model="tempDataset.description"
            id="datasetDescription"
            class="form-control"
          />
        </div><!-- /.form-group -->

        <!-- PROCCESSING LOADER -->
        <div
          v-if="$store.state.display.processingDataset"
          class="processing-spinner-container"
        >
          <div class="processing-spinner"><i class="fad fa-server"></i> Processing data...</div><!-- /.procesing-spinner -->
        </div><!-- /.processing-spinner-container -->

        <!-- UPLOAD FILE -->
        <div
          v-if="$store.state.display.editMode == false"
          class="form-group"
        >
          <label for="dataFilesInput">Upload Data File<br><small>Can be a .txt, .csv, .geojson, .tif, .tiff, .kmz, .kml, or zipped shapefiles file with 'LAT' and 'LNG' or 'Latitude' and 'Longitude' headers.</small></label>
          <DataFilesInput
            :farm="$store.state.farm"
            v-on:dataFilesDelivery="dataFilesDelivery($event)"
          ></DataFilesInput>
        </div><!-- /.form-group -->
        <div class="drawer-footer">
          <button
            v-if="!$store.state.display.editMode && $store.state.display.datasetReady"
            @click="createDataset()"
            class="btn btn-primary mr-1 w-50"
          >
            Submit
          </button>
          <button
            v-if="$store.state.display.editMode"
            @click="createDataset()"
            class="btn btn-primary mr-1 w-50"
            :disabled="isSaving"
          >
            <span v-if="!isSaving">
              <i class="fas fa-save"></i> Save
            </span>
            <span v-else>
              <i class="fas fa-spinner fa-spin"></i> Saving...
            </span>
          </button>
          <button
            v-if="$store.state.display.editMode && !dataset.dynamic && $store.state.folder.id == 'trash' && $store.state.role === 'Administrator'"
            @click="confirmDelete = true"
            class="btn btn-danger mr-1"
          >
            Delete
          </button>
          <button
            v-if="$store.state.display.editMode && dataset.dynamic && $store.state.folder.id == 'trash' && $store.state.role === 'Administrator'"
            @click="confirmDeleteDynamic = true"
            class="btn btn-danger mr-1"
          >
            Delete
          </button>
          <button
            v-if="$store.state.display.editMode && !dataset.dynamic && $store.state.folder.id != 'trash' && $store.state.role === 'Administrator'"
            @click="confirmTrash = true"
            class="btn btn-danger mr-1"
          >
            Trash
          </button>
          <button
            v-if="$store.state.display.editMode && dataset.dynamic && $store.state.folder.id != 'trash' && $store.state.role === 'Administrator'"
            @click="confirmTrashDynamic = true"
            class="btn btn-danger mr-1"
          >
            Trash
          </button>
          <button
            @click="closeCreateDatasetDrawer()"
            class="btn btn-secondary"
          >
            Cancel
          </button>
        </div><!-- /.float-right -->
      </form>

    </b-card>
    <Confirm
      v-if="confirmTrash"
      text="Are you sure you want to trash this dataset? You can restore items from the trash."
      v-on:confirmed="trashDataset($event)"
    />
    <Confirm
      v-if="confirmTrashDynamic"
      text="Are you sure you want to trash this dynamic dataset? This will also deactivate this collector. You can restore items from the trash."
      v-on:confirmed="trashDataset($event)"
    />
  </div><!-- /#createMapDrawer -->
</template>

<script>
import Confirm from '../Confirm'
import firebase from 'firebase/compat/app'
import DataFilesInput from './DataFilesInput.vue'
import axios from 'axios'
import { deriveHeaders } from '@/lib/deriveHeaders'
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      confirmTrash: false,
      confirmTrashDynamic: false,
      confirmDelete: false,
      confirmDeleteDynamic: false,
      selectedFile: null,
      headers: [],
      captured: {
        utcStart: null,
        utcEnd: null
      },
      geoJsonFileUrl: '',
      // The converted GeoJSON, fetched once in dataFilesDelivery; headers
      // are derived from it and the map preview renders from it.
      previewGeoJson: null,
      jpgFileUrl: '',
      drawControl: {},
      drawEventsLog: [],
      tempDataset: {},
      isSaving: false
    }
  },
  components: {
    Confirm,
    DataFilesInput
  },
  computed: {
    dataset: {
      get () {
        return this.$store.state.dataset
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'dataset', value: value })
      }
    }
  },
  mounted () {
    if (this.$store.state.display.editMode === true) {
      this.tempDataset = this.dataset
      this.getFileUrl()
    } else {
      this.dataset = {}
      this.tempDataset = {
        name: '',
        description: '',
        headers: [],
        file: false
      }
      this.$store.dispatch('removeAllLayers')
      this.$store.commit('setDatasetReady', false)
    }
  },
  methods: {
    enableMapEditing () {
      const map = this.$store.state.mapObject
      // DRAW SETTINGS
      this.drawControl = new MapboxDraw({ // eslint-disable-line
        displayControlsDefault: false,
        controls: {
          trash: true
        }
      })
      map.addControl(this.drawControl)
      axios.get(this.geoJsonFileUrl).then(response => {
        this.originalGeoJson = response.data
        // Add indexes for reference into features
        response.data.features.forEach((feature, i) => {
          feature.properties.index = i
        })
        this.drawControl.add(response.data)
        // When A Feature is created, write it to this.block.footprint
        const self = this
        map.on('draw.delete', function (e) {
          e.features.forEach(feature => {
            const drawEvent = {
              type: e.type,
              geometry: feature.geometry,
              dataPointId: feature.properties.dataPointId || false,
              index: feature.properties.index || false
            }
            self.drawEventsLog.push(drawEvent)
          })
          console.log(self.drawEventsLog)
        })
        map.on('draw.update', function (e) {
          console.log(e)
          e.features.forEach(feature => {
            const drawEvent = {
              type: e.type,
              geometry: feature.geometry,
              dataPointId: feature.properties.dataPointId || false,
              index: feature.properties.index || false
            }
            self.drawEventsLog.push(drawEvent)
          })
          // const drawEvent = { type: e.type, geometry: e.features[0].geometry, dataPointId: e.features[0].properties.dataPointId || false }
          // self.drawEventsLog.push(drawEvent)
          console.log(self.drawEventsLog)
        })
      })
    },
    trashDataset (confirmed) {
      if (confirmed) {
        this.confirmTrash = false
        this.confirmTrashDynamic = false
        fb.datasetsCollection.doc(this.$store.state.dataset.id).update({
          updatedOn: new Date(),
          updatedBy: this.$store.state.currentUser.uid,
          folderId: 'trash'
        }).then(() => {
          this.dataset = {}
          this.$router.push('/f/' + this.$store.state.farm.id)
          this.$store.dispatch('initFarmMap')
          this.$store.commit('hideDrawer', 'createDataset')
          this.$store.commit('setAlert', { active: true, message: 'Dataset successfully trashed.', level: 'alert-info', timeout: 3000 })
        })
        if (this.dataset.dynamic) {
          fb.collectorsCollection.doc(this.dataset.collectorId).update({
            updatedOn: new Date(),
            updatedBy: this.$store.state.currentUser.uid,
            trashed: true
          })
        }
      }
    },
    getFileUrl () {
      const self = this
      // Get GeoJson File URL
      const geoJsonPath = this.tempDataset.file.geoJsonPath
      const geoJsonStorageRef = firebase.storage().ref(geoJsonPath)
      geoJsonStorageRef.getDownloadURL().then(geoFileUrl => {
        self.geoJsonFileUrl = geoFileUrl
        self.$store.dispatch('removeAllLayers')
        self.enableMapEditing()
        // self.renderMapPreview()
      }).catch(err => {
        console.log(err)
      })
    },
    renderMapPreview () {
      const self = this
      console.log('Map Preview')
      mapboxgl.accessToken = 'pk.eyJ1IjoibGVyZ3AiLCJhIjoiY2p4bmI1NzNzMGN0MTNjcGx4cjF4eDBtdSJ9.2C0FEHhNZ-jGd7jgIRTrEQ' // eslint-disable-line
      const map = this.$store.state.mapObject

      if (self.geoJsonFileUrl) {
        // Reuse the GeoJSON dataFilesDelivery already fetched (and derived
        // headers from) rather than downloading the whole file a second time.
        const source = self.previewGeoJson
          ? Promise.resolve({ data: self.previewGeoJson })
          : axios.get(self.geoJsonFileUrl)
        source.then(response => {
          map.addSource('geoJsonSource', {
            type: 'geojson',
            data: response.data
          })
          const geomType = response.data.features[0].geometry.type
          if (geomType === 'Polygon' || geomType === 'MultiPolygon') {
            map.addLayer({
              id: 'geojsonMapPreview',
              type: 'fill',
              source: 'geoJsonSource',
              paint: {
                'fill-outline-color': 'white',
                'fill-opacity': 0.8,
                'fill-color': '#ffc107'
              }
            })
          } else if (geomType === 'LineString' || geomType === 'MultiLineString') {
            map.addLayer({
              id: 'geojsonMapPreview',
              type: 'line',
              source: 'geoJsonSource',
              paint: {
                'line-color': '#ffc107',
                'line-width': 2,
                'line-opacity': 0.8
              }
            })
          } else {
            map.addLayer({
              id: 'geojsonMapPreview',
              type: 'circle',
              source: 'geoJsonSource',
              layout: {},
              paint: {
                'circle-radius': self.$store.state.defaults.pointStops,
                'circle-color': '#ffc107'
              }
            })
          }
          map.fitBounds(turf.bbox(response.data), { // eslint-disable-line
            padding: 20,
            animate: false
          })
          // Headers are derived (union across ALL features) in
          // dataFilesDelivery BEFORE the dataset is marked ready; this is
          // only a fallback for the raster/legacy paths that reach here
          // without them.
          if (!self.tempDataset.headers || !self.tempDataset.headers.length) {
            self.tempDataset.headers = deriveHeaders(response.data)
          }
          self.$store.commit('setProcessingDataset', false)
        })
      }

      if (self.jpgFileUrl) {
        if (map.getLayer('rasterLayer')) {
          map.removeLayer('rasterLayer')
          map.removeSource('rasterSource')
        }
        map.addSource('rasterSource', {
          type: 'image',
          url: self.jpgFileUrl,
          coordinates: [
            [self.tempDataset.file.xMin, self.tempDataset.file.yMax], // top left
            [self.tempDataset.file.xMax, self.tempDataset.file.yMax], // top right
            [self.tempDataset.file.xMax, self.tempDataset.file.yMin], // bottom right
            [self.tempDataset.file.xMin, self.tempDataset.file.yMin] // bottom left
          ]
        })
        this.$store.state.mapObject.addLayer({
          id: 'rasterLayer',
          source: 'rasterSource',
          type: 'raster',
          paint: {
            'raster-opacity': 0.85
          }
        })
      }
    },
    closeCreateDatasetDrawer () {
      if (this.$store.state.display.editMode) {
        const map = this.$store.state.mapObject
        map.removeControl(this.drawControl)
        this.drawEventsLog = []
        this.$store.dispatch('launchDataset', { dataset: this.dataset })
      } else {
        this.$store.dispatch('removeAllLayers')
        // this.$store.commit('setDrawer', { name: 'createDatasetDrawer', position: 'out' })
        // Delete the files
        if (this.tempDataset.file) {
          // Original file
          const mediaPath = this.tempDataset.file.path
          const fileRef = firebase.storage().ref(mediaPath)
          fileRef.delete()

          if (this.tempDataset.file.geoJsonPath) {
            // GeoJson File
            const geoJsonMediaPath = this.tempDataset.file.geoJsonPath
            const geoJsonFileRef = firebase.storage().ref(geoJsonMediaPath)
            geoJsonFileRef.delete()
          }

          if (this.tempDataset.file.jpgPath) {
            console.log(this.tempDataset)
            // JPG File
            const jpgMediaPath = this.tempDataset.file.jpgPath
            const jpgFileRef = firebase.storage().ref(jpgMediaPath)
            jpgFileRef.delete()
          }
        }
      }
      this.$store.commit('setEditMode', false)
      this.$store.commit('hideDrawer', 'createDataset')
      // const self = this
      // setTimeout(() => {
      //   self.$store.commit('setEditMode', false)
      //   fb.datasetsCollection.doc(self.$store.state.dataset.id).get().then(newDoc => {
      //     self.dataset = newDoc.data()
      //     self.dataset.id = newDoc.id
      //     self.$store.dispatch('removeAllLayers')
      //     self.$store.dispatch('mapDataset', self.dataset)
      //   })
      // }, 300)
    },
    dataFilesDelivery (dataFilesPayload) {
      console.log(dataFilesPayload)
      const self = this
      self.tempDataset.file = dataFilesPayload
      if (dataFilesPayload.raster) {
        console.log('This is a raster')
        // Go get the download URL for jpg file
        const jpgPath = self.tempDataset.file.jpgPath
        const jpgStorageRef = firebase.storage().ref(jpgPath)
        // Only fit to the raster's extent if we actually have its bounds;
        // calling fitBounds with undefined coords throws and would abort the
        // whole delivery (leaving the dataset un-creatable).
        const hasBounds = dataFilesPayload.xMin != null && dataFilesPayload.yMin != null &&
          dataFilesPayload.xMax != null && dataFilesPayload.yMax != null
        if (hasBounds) {
          this.$store.state.mapObject.fitBounds([
            [dataFilesPayload.xMin, dataFilesPayload.yMin],
            [dataFilesPayload.xMax, dataFilesPayload.yMax]
          ], {
            animate: false
          })
        }
        jpgStorageRef.getDownloadURL().then(fileUrl => {
          console.log(fileUrl)
          self.jpgFileUrl = fileUrl
          self.renderMapPreview()
          self.$store.commit('setDatasetReady', true)
        }).catch(function (error) {
          // The JPG preview couldn't be generated. Some rasters (e.g.
          // single-band / floating-point GeoTIFFs like DEMs) can't be
          // rendered to a thumbnail by the upload processor, so the .jpg
          // never appears and this 404s. The raster itself uploaded fine —
          // so DON'T block creation on a missing preview. Mark the dataset
          // ready and let the user proceed without a thumbnail.
          console.log('Raster preview unavailable:', (error && error.code) || error)
          self.jpgFileUrl = null
          self.$store.commit('setDatasetReady', true)
          self.$store.commit('setAlert', {
            active: true,
            message: 'A preview image could not be generated for this raster, but the file uploaded successfully and the dataset can still be created.',
            level: 'alert-info'
          })
        })
      } else {
        // THE ROOT FIX for "new dataset has no headers until I refresh":
        // previously the dataset was marked ready the instant the download
        // URL resolved, while the headers were computed at the END of a
        // separate, un-awaited fetch of the whole file — so on any file big
        // enough to take a moment, the user could click Create before the
        // headers existed and the doc was persisted with `headers: []`
        // (and even when the race was won, only features[0]'s keys were
        // used). Now the GeoJSON is fetched and headers derived as a union
        // across ALL features BEFORE the dataset can be created. The fetched
        // data is kept for the map preview so the file downloads once.
        const geoJsonPath = self.tempDataset.file.geoJsonPath
        const geoJsonStorageRef = firebase.storage().ref(geoJsonPath)
        geoJsonStorageRef.getDownloadURL().then(fileUrl => {
          self.geoJsonFileUrl = fileUrl
          return axios.get(fileUrl)
        }).then(response => {
          self.previewGeoJson = response.data
          self.tempDataset.headers = deriveHeaders(response.data)
          self.renderMapPreview()
          self.$store.commit('setDatasetReady', true)
        }).catch(function (error) {
          console.log(error)
          self.$store.commit('setProcessingDataset', false)
          self.$store.commit('setAlert', {
            active: true,
            message: 'The converted file could not be read. Please try the upload again — if it keeps failing, check that the file has LAT/LNG (or Latitude/Longitude) columns.',
            level: 'alert-danger',
            timeout: 12000
          })
        })
      }
    },
    createDataset () {
      // Set saving state
      this.isSaving = true
      
      if (!this.$store.state.display.editMode) {
        // Belt and braces: headers are derived before the dataset is
        // creatable, but never persist an empty list when the data is in
        // hand — derive from the cached preview GeoJSON as a last resort.
        if ((!this.tempDataset.headers || !this.tempDataset.headers.length) && this.previewGeoJson) {
          this.tempDataset.headers = deriveHeaders(this.previewGeoJson)
        }
        fb.datasetsCollection.add({
          name: this.tempDataset.name || '',
          description: this.tempDataset.description || '',
          headers: this.tempDataset.headers || [],
          farmId: this.$store.state.farm.id,
          createdOn: new Date(),
          createdBy: this.$store.state.currentUser.uid,
          updatedOn: new Date(),
          updatedBy: this.$store.state.currentUser.uid,
          file: this.tempDataset.file || {},
          folderId: this.$store.state.folder.id
        }).then(doc => {
          this.$store.dispatch('fetchDatasets', this.$store.state.farm.id)
          // this.$store.commit('toggleModal', 'createDataset')
          this.dataset.id = doc.id
          fb.datasetsCollection.doc(doc.id).get().then(newDoc => {
            this.dataset = newDoc.data()
            this.dataset.id = newDoc.id
            // this.$store.dispatch('removeAllLayers')
            // this.$store.dispatch('mapDataset', this.dataset)
            this.$store.dispatch('launchDataset', { dataset: this.dataset })
            // Reset saving state for new dataset creation
            this.isSaving = false
          })
        }).catch(err => {
          console.log(err)
          // Reset saving state on error for new dataset creation
          this.isSaving = false
        })
      } else {
        const map = this.$store.state.mapObject
        map.removeControl(this.drawControl)
        fb.datasetsCollection.doc(this.$store.state.dataset.id).update({
          name: this.tempDataset.name || '',
          description: this.tempDataset.description || '',
          headers: this.tempDataset.headers || [],
          farmId: this.$store.state.farm.id,
          updatedOn: new Date(),
          updatedBy: this.$store.state.currentUser.uid,
          file: this.tempDataset.file || {}
        }).then(() => {
          let collectorId
          if (this.$store.state.dataset.dynamic) {
            collectorId = this.$store.state.dataset.collectorId
            fb.collectorsCollection.doc(collectorId).update({
              description: this.tempDataset.description || '',
              name: this.tempDataset.name || '',
              updatedBy: this.$store.state.currentUser.uid,
              updatedOn: new Date(),
              reCompile: true
            })
          }
          if (this.drawEventsLog.length > 0) {
            if (this.$store.state.dataset.dynamic) {
              return true
            } else {
              console.log(this.drawEventsLog)
              return fb.editRequestsCollection.add({
                createdOn: new Date(),
                createdBy: this.$store.state.currentUser.uid,
                farmId: this.$store.state.farm.id,
                datasetId: this.$store.state.dataset.id,
                edits: this.drawEventsLog
              })
            }
          } else {
            // Reset saving state when no edits are needed
            this.isSaving = false
            return true
          }
        }).then(() => {
          if (this.$store.state.dataset.dynamic) {
            // Loop through edits and adjust dataPoints
            const finalEdits = {}
            this.drawEventsLog.forEach((drawEvent, i) => {
              if (drawEvent.type === 'draw.delete') {
                finalEdits[drawEvent.dataPointId] = false
              }
              if (drawEvent.type === 'draw.update') {
                finalEdits[drawEvent.dataPointId] = drawEvent.geometry
              }
            })
            const editKeys = Object.keys(finalEdits)
            editKeys.forEach(dataPointId => {
              if (finalEdits[dataPointId] === false) {
                fb.collectorsCollection.doc(this.$store.state.dataset.collectorId).collection('dataPoints').doc(dataPointId).delete()
              } else {
                const geoPoint = new firebase.firestore.GeoPoint(finalEdits[dataPointId].coordinates[1], finalEdits[dataPointId].coordinates[0])
                fb.collectorsCollection.doc(this.$store.state.dataset.collectorId).collection('dataPoints').doc(dataPointId).update({
                  geolocation: geoPoint,
                  updatedBy: this.$store.state.currentUser.uid,
                  updatedOn: new Date()
                })
              }
            })
            this.$store.dispatch('removeAllLayers')
            // this.$store.commit('resetDrawers')
            console.log('Remove all Drawers')
            this.$store.commit('hideAllDrawers')
            setTimeout(() => {
              this.$store.commit('setAlert', { active: true, message: 'Dataset being edited! Hold tight!', level: 'alert-info' })
              this.$store.commit('hideDrawer', 'createDataset')
              // this.$store.commit('setStateProperty', { property: 'showCreateDatasetDrawer', value: false })
            }, 300)
            setTimeout(() => {
              this.$store.commit('setAlert', { active: false, message: 'Dataset being edited! Hold tight!', level: 'alert-info' })
              // this.$store.dispatch('mapDataset', this.$store.state.dataset).then(() => {
              //   let newData = true
              //   fb.datasetsCollection.doc(this.$store.state.dataset.id).onSnapshot(snapshot => {
              //     const datasetDoc = snapshot.data()
              //     datasetDoc.id = snapshot.id
              //     const filePath = this.$store.state.dataset.file.geoJsonPath || ''
              //     const newFilePath = datasetDoc.file.geoJsonPath
              //     // Only rerender if new geoJson file
              //     if (filePath !== newFilePath && newData === true) {
              //       newData = false
              //       this.$store.commit('setDataset', datasetDoc)
              //       const self = this
              //       setTimeout(function () {
              //         self.$store.commit('setAlert', { active: false })
              //         self.$store.dispatch('removeAllLayers')
              //         self.$store.dispatch('mapDataset', datasetDoc)
              //       }, 1000)
              //     }
              //   })
              // })
              this.$store.dispatch('launchDataset', { dataset: this.dataset })
              // Reset saving state for dynamic datasets
              this.isSaving = false
            }, 5000)
                      } else {
              if (this.drawEventsLog.length < 1) {
                this.$store.dispatch('fetchDatasets', this.$store.state.farm.id)
                this.$store.dispatch('launchDataset', { dataset: this.dataset })
                // Reset saving state for no edits
                this.isSaving = false
              } else {
                // SHOW LOADING STATE AND LISTEN FOR EDIT COMPLETION
                this.$store.commit('setAlert', { active: true, message: 'Dataset being edited! Processing your changes...', level: 'alert-info' })
                this.$store.commit('hideDrawer', 'createDataset')
                
                // Listen for dataset changes to detect when edit is complete
                let newData = true
                const unsubscribe = fb.datasetsCollection.doc(this.$store.state.dataset.id).onSnapshot(snapshot => {
                  const datasetDoc = snapshot.data()
                  datasetDoc.id = snapshot.id
                  const filePath = this.$store.state.dataset.file.geoJsonPath || ''
                  const newFilePath = datasetDoc.file.geoJsonPath
                  
                  // Only rerender if new geoJson file (indicating edit completion)
                  if (filePath !== newFilePath && newData === true) {
                    newData = false
                    console.log('Dataset edit completed, refreshing data...')
                    
                    // Update the dataset in store
                    this.$store.commit('setDataset', datasetDoc)
                    
                    // Show success message
                    this.$store.commit('setAlert', { active: true, message: 'Dataset edit completed! Refreshing map...', level: 'alert-success' })
                    
                    // Wait a moment then refresh the map
                    setTimeout(() => {
                      this.$store.commit('setAlert', { active: false })
                      this.$store.dispatch('removeAllLayers')
                      this.$store.dispatch('mapDataset', datasetDoc)
                      this.$store.commit('showDrawer', 'datasetDetails')
                      // Reset saving state when edit completes
                      this.isSaving = false
                    }, 1000)
                    
                    // Unsubscribe from changes
                    unsubscribe()
                  }
                })
                
                // Fallback: if no changes detected after 30 seconds, refresh anyway
                setTimeout(() => {
                  if (newData) {
                    console.log('No dataset changes detected, refreshing anyway...')
                    unsubscribe()
                    this.$store.commit('setAlert', { active: false })
                    this.$store.dispatch('launchDataset', { dataset: this.dataset })
                    // Reset saving state in fallback case
                    this.isSaving = false
                  }
                }, 30000)
              }
            }
        }).then(() => {
          // Reset saving state on success
          this.isSaving = false
        }).catch(err => {
          console.log(err)
          // Reset saving state on error
          this.isSaving = false
        })
      }
    }
  }
}
</script>
